var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gameRank)?_c('div',{class:_vm.classes},[_c('span',[_vm._v(_vm._s(_vm.gameRank.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }